import { GroupAssessmentSummary } from './group-assessment-summary';
import { GroupCompletionRateStats } from './group-completion-rate-stats';
import { CandidatesGroupWithMostAttempt } from './candidates-group-with-most-attempt';

export class GroupStatistics {
  groupAssessmentSummary: GroupAssessmentSummary[];
  groupCompletionRateStats: GroupCompletionRateStats[];
  groupCandidateStats: CandidatesGroupWithMostAttempt[];

  constructor(
    groupAssessmentSummary: GroupAssessmentSummary[],
    groupCompletionRateStats: GroupCompletionRateStats[],
    groupCandidateStats: CandidatesGroupWithMostAttempt[]
  ) {
    this.groupAssessmentSummary = groupAssessmentSummary;
    this.groupCompletionRateStats = groupCompletionRateStats;
    this.groupCandidateStats = groupCandidateStats;
  }
}
